/** 仅读取环境变量 / 纯域名规则，不加载 firebase SDK */

/**
 * 按当前页面 host 选择 Firebase authDomain，使 Redirect 尽量与 App 同站。
 * env 仅作未知域兜底；localhost 固定用默认 firebaseapp 域。
 *
 * @param {string} [hostname]
 * @param {string} [envAuthDomain]
 * @returns {string}
 */
export function resolveFirebaseAuthDomain(hostname = '', envAuthDomain = '') {
  const host = String(hostname || '')
    .trim()
    .toLowerCase()
    .replace(/\.+$/, '');
  const fallback = String(envAuthDomain || '')
    .trim()
    .replace(/\/+$/, '');

  if (!host || host === 'localhost' || host === '127.0.0.1') {
    return 'pm-project-b94aa.firebaseapp.com';
  }
  if (host === 'login.deepsage.live' || host === 'login.deepsage.app') {
    return host;
  }
  if (host === 'deepsage.live' || host.endsWith('.deepsage.live')) {
    return 'login.deepsage.live';
  }
  if (
    host === 'deepsage.app' ||
    host.endsWith('.deepsage.app') ||
    host === 'deepsage.net' ||
    host.endsWith('.deepsage.net')
  ) {
    return 'login.deepsage.app';
  }
  return fallback;
}

export function isFirebaseConfigured() {
  return Boolean(
    process.env.VUE_APP_FIREBASE_API_KEY &&
      process.env.VUE_APP_FIREBASE_AUTH_DOMAIN &&
      process.env.VUE_APP_FIREBASE_PROJECT_ID &&
      process.env.VUE_APP_FIREBASE_APP_ID
  );
}
